
type CardSectionProps = {
    title : string;
    subtitle : string;
    image : {
        src : string,
        alt : string,
    },
    shortText? : string;
}

const CardSection = ({ 
    title,
    subtitle,
    image,
    shortText
} : CardSectionProps) => {
  return (
    <div className="card-section">
        <div className="wrapper-small">
            <div className="section-flex">
                <img src={image.src} className="section-image" alt={image.alt} />
                <div className="info-box">
                    {shortText ? <p className="section-subtitle-two">{shortText}</p> : ""}
                    <h2 className="section-title">{title}</h2>
                    <p className="section-subtitle">{subtitle}</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CardSection